import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox, Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'VehTypeName', label: 'Vehicle type Name', minWidth: 100 },
    { id: 'VehTypeAbrv', label: 'Abrv', minWidth: 100 },
    { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const VehicleTypeMst = () => {
    const [formData, setFormData] = useState({
        VehTypeName: '',
        VehTypeAbrv: '',
        Remark: '',
        Status: ''
    });

    const [error, setError] = useState({
        VehTypeName: false,
        FoodGrpName: false
    });

    const navigate = useNavigate();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const location = useLocation();
    const [currentVehTypeId, setCurrentVehTypeId] = useState(null);
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [lastInsertedFoodId, setLastInsertedFoodId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const VehTypeNameRef = useRef(null);
    const FoodGrpNameRef = useRef(null);
    const remarkRef = useRef(null);

    useEffect(() => {
        if (location.state && location.state.VehTypeId) {
            setCurrentVehTypeId(location.state.VehTypeId);
            fetchVehicleTypeMst(location.state.VehTypeId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchVehicleTypeMst = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`MstVehicle/RetriveMstVehType`, {
                VehTypeId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const foodData = response.data.Data[0];
                setFormData({
                    VehTypeName: foodData.VehTypeName,
                    VehTypeAbrv: foodData.VehTypeAbrv,
                    Remark: foodData.Remark,
                });
                setStatus(foodData.Status.toString() || "0");
                setIsFormDisabled(true);
                setCurrentVehTypeId(foodData.VehTypeId);
            }
        } catch (error) {
            toast.error('Error fetching food data. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            try {
                const res = await axiosInstance.post('MstVehicle/GetMstVehTypeDashBoard', {
                    "start": 1,
                    "PageSize": 1,
                    "SearchText": ""
                });
                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (err) {
                toast.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    const handlePrevious = async () => {
        if (currentVehTypeId && currentVehTypeId > 1) {
            await fetchVehicleTypeMst(currentVehTypeId, "P");
        }
    };

    const handleNext = async () => {
        if (currentVehTypeId) {
            await fetchVehicleTypeMst(currentVehTypeId, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === VehTypeNameRef.current) {
                FoodGrpNameRef.current.focus();
            } else {
                remarkRef.current.focus();
            }
        }
    };

    const handleSubmit = async () => {

        let hasError = false;

        if (!formData.VehTypeName) {
            toast.error('Vehicle Type Name is required.');
            setError(prev => ({ ...prev, VehTypeName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, VehTypeName: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                VehTypeName: formData.VehTypeName,
                VehTypeAbrv: formData.VehTypeAbrv,
                Remark: formData.Remark,
                Status: Status
            };

            let response;
            if (mode === 'edit') {
                payload.VehTypeId = currentVehTypeId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axiosInstance.patch(`MstVehicle/UpdateMstVehType`, payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axiosInstance.post(`MstVehicle/InsertMstVehType`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedFoodId(response.data.Data)
                    await fetchVehicleTypeMst(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentVehTypeId(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            toast.error('Error saving/updating food. Please try again.');
        }
    };

    //    const handleEdit = () => {
    //     setMode(FORM_MODE.edit);
    //     setIsFormDisabled(false);
    // };

    const handleEdit = async () => {
        setMode("edit");
        setIsFormDisabled(false);
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            VehTypeName: '',
            VehTypeAbrv: '',
            Remark: '',
            Status: ''
        });
        setCurrentVehTypeId(null);

        setTimeout(() => {
            VehTypeNameRef.current.focus();
        }, 0);
    };

    const handleCancel = async () => {
        if (mode === "add") {
            await fetchVehicleTypeMst(1, "L");
        } else {

            await fetchVehicleTypeMst(currentVehTypeId, "R");
        }
        setStatus("1");
        setMode("view");
        setIsFormDisabled(true);
    };

    const handleExit = () => {
        navigate('/vehicle-type-table');
    }

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        try {
            setOpenConfirmDialog(false);
            const response = await axiosInstance.post("MstVehicle/DeleteMstVehType", {
                VehTypeId: currentVehTypeId
            });

            if (response.data.Status === 0) {
                toast.success(response.data.Message || 'Record Deleted.');
                await fetchVehicleTypeMst(currentVehTypeId, "P");
                setStatus("1");
                setMode('view');
                setIsFormDisabled(true);
            } else {
                toast.warn(response.data.Message || 'Failed to delete the record.');
            }
        } catch (error) {
            console.error("Error deleting record: ", error);
        }
    };


    return (
        <>
            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentVehTypeId || currentVehTypeId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                // sx={{ margin: '0px 10px' }}
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentVehTypeId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Vehicle Type Master
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName={"Vehicle Type"}
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                    id="VehTypeName"
                                    name="VehTypeName"
                                    label={
                                        <span>
                                            Vehicle Type Name <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.VehTypeName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    error={error.VehTypeName}
                                    helperText={error.VehTypeName && ""}
                                    inputRef={VehTypeNameRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>



                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                    id="VehTypeAbrv"
                                    name="VehTypeAbrv"
                                    label="VehTypeAbrv"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.VehTypeAbrv}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>
                            {/* <Grid item xs={12} md={4} lg={4}>
                                <CustomAutocomplete
                                    options={unit}
                                    id="unit-autocomplete"
                                    name="UnitId"
                                    label={<span>Unit<span style={{ color: 'red' }}>*</span></span>}
                                    value={unit.find(u => u.Id === formData.UnitId) || ''}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    className="custom-textfield"
                                    variant='filled'
                                />
                            </Grid> */}
                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label="Remark"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={1}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>

                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title="Vehicle Type Master"
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />
                }
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default VehicleTypeMst;